import styled from "styled-components";

export const Container = styled.div``;
export const SelectedShippingServiceWrap = styled.div`
  margin-top: 20px;
`;
